import { checkPrevValue } from "./checkCondition.js"

function calculateAmounts(amount, installments) {
  if (installments <= 0) {
    throw new Error("Installments must be a positive integer");
  }

  const baseInstallment = Math.round(amount / installments);
  let remainingAmount = amount;
  const result = [];

  for (let i = 0; i < installments - 1; i++) {
    result.push(baseInstallment);
    remainingAmount -= baseInstallment;
  }

  // The last installment is the remaining amount
  result.push(remainingAmount);

  return result;
}

function calculatePaymentDates(date, daysToFirstPayment, installments, intervalDays) {
  if (installments < 1) {
    throw new Error("There must be at least one installment.");
  }
  if (intervalDays < 1) {
    throw new Error("Interval days must be a positive integer.");
  }

  const initialDate = new Date(date);
  const paymentDates = [];

  // Calculate the first payment date
  let paymentDate = new Date(initialDate);
  paymentDate.setDate(paymentDate.getDate() + daysToFirstPayment);
  paymentDates.push(paymentDate.toISOString());

  // Calculate the subsequent payment dates
  for (let i = 1; i < installments; i++) {
    paymentDate = new Date(paymentDate);
    paymentDate.setDate(paymentDate.getDate() + intervalDays);
    paymentDates.push(paymentDate.toISOString());
  }

  return paymentDates;
}

const calculateCurrencies = (currency, installments) => {
   if (installments <= 0) {
    throw new Error("Installments must be a positive integer");
  }

  const result = [];

  for (let i = 0; i < installments; i++) {
    result.push(currency);
  }

  return result;
}

function calculatePayments(amounts, paymentDates, currencies, amountsBaseCurrency, transferMap) {
  if (amounts.length !== paymentDates.length) {
    throw new Error("Amounts and payment dates arrays must have the same length.");
  }

  const result = [];

  // Extract keys from transferMap
  const dateKey = transferMap['paymentDate'];
  const amountKey = transferMap['totalGrossSalesAmount'];
  const currencyKey = transferMap['currency'];
  const amountBaseCurrencyKey = transferMap['totalGrossSalesAmountBaseCurrency'];

  for (let i = 0; i < amounts.length; i++) {
    const paymentObj = {
      [dateKey]: paymentDates[i],
      [amountKey]: amounts[i],
      [currencyKey]: currencies[i],
      [amountBaseCurrencyKey]: amountsBaseCurrency[i]
    };
    result.push(paymentObj);
  }

  return result;
}


export const createSinglePayment = (data, subEntity, transferMap) => {
  
  //Skips the creation of Payments if customerPayments is true
  if (data.customPayments) return
  
  let subEntityItem = {}

  // Iterate over the keys of transferMap
  for (const key in transferMap) {
    if (transferMap.hasOwnProperty(key)) { // Ensure it's an own property
      subEntityItem[transferMap[key]] = data[key];
    }
  }

  if (data.id) {
    subEntityItem['paymentId'] = `${data.id}.1`
  }

  // Return new object instead of mutating
  return {
    ...data,
    [subEntity]: [subEntityItem],
    numPayments: 1
  }
}

const generatePaymentSchedule = (data, transferMap) => {
  //Skips the creation of Payments if customerPayments is true
  if (data.customPayments) return null

  
  //Setup the variables to use
  const daysToFirstPayment = data['paymentTermDays'] || 1
  const installments = data['paymentInstallments'] || 1
  const intervalDays = data['paymentIntervalDays'] || 30

  //Calculate 2 arrays with correct amounts and dates
  const amounts = calculateAmounts(data['totalGrossSalesAmount'], installments)
  const paymentDates = calculatePaymentDates(data['date'], daysToFirstPayment, installments, intervalDays);
  const currencies = calculateCurrencies(data['currency'], installments)
  const amountsBaseCurrency = amounts.map(amount => amount / data['exchangeRate'])

  console.log('amounts: ', amounts)
  console.log('amountsBaseCurrency: ', amountsBaseCurrency)

  //Combine Amount and Dates using the transferMap
  const cPayments = calculatePayments(amounts, paymentDates, currencies, amountsBaseCurrency, transferMap)
  console.log('cPayments: ', cPayments)
  //AddPayments Id to payments
  let payments = []

  for (let i = 0; i < cPayments.length; i++) {
    const payment = { ...cPayments[i] };
    //PaymentId will be invoice id + . tranche
    if (data.id) payment.paymentId = `${data.id}.${i + 1}`
    payments.push(payment)
  }

  //Returning Payments and Installments
  return { payments, installments }
}

const subCalcPayments = (data, operation, prevData) => {
  const { conditionField, subEntity, transferMap } = operation
  let result

  const isTrue = checkPrevValue(data, prevData, conditionField)

  if (isTrue) {
    // Create new data object with default totalGrossSalesAmount if needed
    const updatedData = data['totalGrossSalesAmount'] === undefined
      ? { ...data, totalGrossSalesAmount: 0 }
      : data

    if (updatedData['paymentSchedule']) {
      // Respect custom payments: do not auto-generate, return data unchanged
      if (updatedData.customPayments) {
        result = updatedData
      } else {
        //This generates the Payment Schedule
        const schedule = generatePaymentSchedule(updatedData, transferMap)
        if (schedule) {
          const { payments, installments } = schedule
          //Return new object with payments and numPayments
          result = {
            ...updatedData,
            [subEntity]: payments,
            numPayments: installments
          }
        } else {
          // Fallback: keep data as-is when schedule generation is skipped
          result = updatedData
        }
      }
    } else {
      result = createSinglePayment(updatedData, subEntity, transferMap)
    }
  }

  return result || data
}

export default subCalcPayments
